import styled from 'styled-components'
import { blackOrange, textMuted } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'
import { Button } from '@components/Button'

export const HeroWrap = styled.header`
	position: relative;
`

export const HeroTopBar = styled.div`
	display: flex;
	justify-content: flex-end;
	min-height: 8px;
`

export const HeroCenter = styled.div`
	text-align: center;
	padding: 12px 0 44px;

	${media.bentoCollapse} {
		padding: 8px 0 32px;
	}
`

export const HeroTitle = styled.h1`
	${text.hero}
	font-size: clamp(${fontSizes.heroSm}, 5vw, ${fontSizes.hero});
	color: ${blackOrange};
	margin: 0 0 14px;
	text-wrap: balance;
	overflow-wrap: anywhere;

	${media.phone} {
		font-size: ${fontSizes.display};
	}
`

export const HeroMeta = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	flex-wrap: wrap;
`

/* Plain text, no fill — the day count reads as a label beside the dates. */
export const DaysPill = styled.span`
	${text.labelSm}
	color: ${textMuted};
`

export const HeroDates = styled.span`
	${text.body}
	color: ${textMuted};
`

export const HeroAvatars = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 12px;
	margin-top: 14px;
`

/** Invite entry point living inside the hero's avatar row: the Button's pill shape, which sits right next to round avatars. */
export const InviteChip = styled(Button).attrs({ variant: 'primary' as const, size: 'sm' as const, shape: 'pill' as const })``
